import React, { useState } from 'react';

function RateEncryptDecrypt({ rateData,startSymbol="$",endSymbol="/hr" }) {
  const [showFee, setShowFee] = useState(false);
  const handleToggle = (e) => {
    e.stopPropagation();
    setShowFee((prev) => !prev);
  };
  return (
    <>
      <style>{`
        .wf-rate-display-container {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          vertical-align: middle !important;
        }
        .wf-rate-value-text {
          font-weight: 700 !important;
          color: #0f172a !important;
          font-size: 11px !important;
          letter-spacing: 0.1px !important;
        }
        .wf-rate-masked {
          display: inline-flex !important;
          align-items: center !important;
          gap: 3px !important;
          height: 18px !important;
        }
        .wf-rate-masked-dot {
          width: 5px !important;
          height: 5px !important;
          background-color: #64748b !important;
          border-radius: 50% !important;
          display: inline-block !important;
          opacity: 0.65 !important;
        }
        .wf-eye-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 22px !important;
          height: 18px !important;
          border-radius: 5px !important;
          border: 1px solid #cbd5e1 !important;
          background: #f8fafc !important;
          color: #64748b !important;
          transition: all 0.18s ease !important;
          cursor: pointer !important;
          padding: 0 !important;
          outline: none !important;
          flex-shrink: 0 !important;
        }
        .wf-eye-btn:hover {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
          transform: translateY(-0.5px) !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-eye-btn:active {
          transform: scale(0.95) !important;
        }
        .wf-eye-btn i {
          font-size: 10px !important;
        }
      `}</style>
      <span className="wf-rate-display-container">
        {showFee ? (
          <span className="wf-rate-value-text">
            {startSymbol}
            {rateData && !isNaN(rateData) ? parseFloat(rateData).toFixed(2) : "0.00"}
            {endSymbol}
          </span>
        ) : (
          <span className="wf-rate-masked" aria-label="Encrypted Rate">
            <span className="wf-rate-masked-dot"></span>
            <span className="wf-rate-masked-dot"></span>
            <span className="wf-rate-masked-dot"></span>
            <span className="wf-rate-masked-dot"></span>
            <span className="wf-rate-masked-dot"></span>
            <span className="wf-rate-masked-dot"></span>
          </span>
        )}
        <button
          title={showFee ? "Hide rate" : "Show rate"}
          aria-label='Toggle Visibility'
          type='button'
          onClick={handleToggle}
          className='wf-eye-btn'
        >
          {showFee ? (
            <i className="fa fa-eye-slash" aria-hidden="true" />
          ) : (
            <i className="fa fa-eye" aria-hidden="true" />
          )}
        </button>
      </span>
    </>
  );
}

export default RateEncryptDecrypt;